import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteNavigationItem = async (id: string) => {
	const url = `/homepage/admin/mobilenavigation/${id}/`;
	await cmsClient.delete(url);
};

const useDeleteNavigationItem = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Navigation item deleted" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["navigation-items"]);
	};

	const mutation = useMutation(deleteNavigationItem, {
		onSuccess,
		onError,
		onSettled
	});

	return mutation;
};

export default useDeleteNavigationItem;
